import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from './sub_components/toast';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as currentBetsService from '../services/currentBetsService'
import * as userService from '../services/userService'
import Autocomplete from 'react-autocomplete';
import Currency from './sub_components/currency'
import { CSVLink } from 'react-csv';
import printJS from 'print-js'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import * as _ from 'lodash'
import * as dateUtil from '../util/date.util'
import { BASE_IMAGE_PATH, BASE_IMAGE_PATH_NEW } from '../configs/api';
import { OPERATOR_ID } from '../configs/const';
import { casinoList } from '../configs/casinoShowList';
import moment from 'moment';
let linkClickTimeout
let printClickTimeout
class CurrentBets extends Component {
   csvLink = React.createRef();
   constructor(props) {
      super(props);
      this.state = {
         user_id: "",
         usersList: [],
         accounts: '',
         sportType: "ALL",
         marketType: "",
         marketName: "",
         eventName: "",
         evts_name: [],
         mkts_name: [],
         bets_data: [],
         csv_json: [],
         pdf_json: [],
         bets_search_data: [],
         toastMsg: "",
         toastType: "",
         last_id: "",
         first_id: "",
         action: "",
         from: "",
         to: "",
         page_no: 1,
         count_records: 0,
         records_display: 25,
         showData: false,
         loader: false,
         total_page: 1,
         casinoShowList:[],
         event_dictionary: {},
      
      };
   }
   async componentDidMount() {
      let userData = localStorage.getItem("tokenData")
      userData = JSON.parse(userData)
      if(!(!!userData && !!userData.sub)){
         localStorage.clear();
         this.props.history.push("/auth")
      }
      let casinoShowList = [];
      for(const clst of casinoList){
         casinoShowList.push(clst.provider);
      }
      this.setState({ accounts: userData.sub, casinoShowList: casinoShowList })
      let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ to: curDate, from: weekDate })
   }
   componentWillUnmount(){
      clearTimeout(linkClickTimeout)
      clearTimeout(printClickTimeout)
   }
   parseToPickerDate(date) {
      let dtArr = date.split("/")
      let dt = dtArr[2] + "-" + (dtArr[0].split("").length === 2 ? dtArr[0] : "0" + dtArr[0]) + "-" + (dtArr[1].split("").length === 2 ? dtArr[1] : "0" + dtArr[1])
      return dt
   }
   parseFilterBody() {
      // let body = {
      //    "filters": {
      //       "BetStatuses": ["PLACED", "REQUESTED", "REJECTED"],
      //       "current_user": this.state.accounts,
      //       "user_id": this.state.user_id,
      //       "amount_from": 0.0,
      //       "amount_to": 0.0,
      //       "competition_id": "",
      //       "sport_type": this.state.sportType,
      //       "event_id": this.state.eventName,
      //       "market_type": this.state.marketType,
      //       "market_id": this.state.marketName,
      //    },
      //    "last_id": this.state.last_id,
      //    "first_id": this.state.first_id,
      //    "action": this.state.action,
      //    "from": new Date(this.state.from).toISOString(),
      //    "to": new Date(this.state.to).toISOString(),
      //    "zone": new Date().getTimezoneOffset(),
      //    "page_no": this.state.page_no,
      //    "count_records": this.state.count_records,
      //    "records_display": this.state.records_display
      // }
      let body = {
         "filters":{
             "userId": this.state.user_id,
             "betStatus": ["PLACED", "REQUESTED", "REJECTED"],
             "marketId": this.state.marketName,
             "eventId": this.state.eventName,
             "competitionId": "",
             "sportType": this.state.sportType,
             "marketType": this.state.marketType,
             "amountFrom": 0.0,
             "amountTo": 0.0
         },
         "lastId": this.state.last_id,
         "firstId": this.state.first_id,
         "action": this.state.action,
         "from": new Date(this.state.from).toISOString(),
         "to": new Date(this.state.to).toISOString(),
         "countRecords": this.state.count_records,
         "pageNo": this.state.page_no,
         "recordsPerPage": this.state.records_display
     
     }
      body = this.clean(body);
      return body
   }
   async submitForm() {
      const self = this;
      let body = this.parseFilterBody()
      await currentBetsService.postApiOpenBets(body).then((res) => {
         if (res.isSuccess) {
            self.setState(
               {
                  bets_data: [],
                  bets_search_data: [],
                  last_id: res.lastId,
                  first_id: res.firstId,
                  action: res.action,
                  page_no: res.pageNo,
                  count_records: res.countRecords,
                  total_page: 1,
                  showData: true,
                  loader: true
               }, () => {
                  this.setState({
                     bets_data: res.items,
                     bets_search_data: res.items,
                     total_page: Math.ceil(res.countRecords / this.state.records_display),
                     loader: false
                  })
               }
            );
         }
         else {
            this.setState({ bets_data: [], bets_search_data: [], showData: true, loader: false, total_page: 1, last_id: "", first_id: "", action: "", page_no: 1, count_records: 0 })
         }
      })
   }
   async onDownload() {
      const self = this;
      this.setState({ csv_json: [] }, () => {
         let order = this.state.bets_search_data
         let items = []
         let dictinory = {}
         for (let x of order) {
            dictinory = {}
            let st = x["createdAt"].split(" ")
            let dtstr = st[0] + "T" + st[1] + ".000+00:00"
            let dt = new Date(dtstr).toLocaleString("hi-IN")
            dictinory["Date&Time"] = dt
            dictinory["User"] = x["username"]
            dictinory["Competition"] = x["competitionName"]
            dictinory["Event"] = x["eventName"]
            dictinory["Market"] = x["marketName"]
            dictinory["Runner"] = x["runnerName"]
            if (x["side"] === 0) {
               dictinory["Side"] = "Back"
            }
            else if (x["side"] === 1) {
               dictinory["Side"] = "Lay"
            }
            else if (x["side"] === -1) {
               dictinory["Side"] = "Unknown"
            }
            else {
               dictinory["Side"] = "-"
            }
            if (x["marketBettingType"] === "LINE") {
               dictinory["Line"] = x["runnerId"]
            }
            else {
               dictinory["Line"] = "-"
            }
            dictinory["Rate"] = x["price"]
            dictinory["Amount"] = x["amount"]
            if (x["eventTypeId"] !== "99") {
               dictinory["Potential Profit"] = x["potentialProfit"]
               dictinory["Potential Loss"] = x["potentialLoss"]
            }
            else {
               dictinory["Potential Profit"] = "-"
               dictinory["Potential Loss"] = "-"
            }
            dictinory["Client IP"] = x["clientIp"]
            items.push(dictinory)
         }
         this.setState({ csv_json: items }, () => {
            linkClickTimeout = setTimeout(function () {
               self.csvLink.current.link.click();
            }, 500)
         })
      })
   }
   async onPDFDownload() {
      this.setState({ pdf_json: [] }, () => {
         this.setState({ pdf_json: this.state.bets_search_data }, () => {
            printClickTimeout = setTimeout(function () {
               printJS({
                  printable: 'printJS-div',
                  type: 'html',
                  style: '@page { size: Letter landscape;}',
                  targetStyles: ['*']
               })
            }, 500)
         })
      })
   }
   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   onSubmit(e) {
      let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > 31) {
         this.props.notify(" Date range must be 1 month. ", "error");
      }
      else {
         this.setState({ action: "", page_no: 1 }, () => { this.submitForm(); });
      }
   }
   resetForm() {
      let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ showData: false, user_id: "", usersList: [], bets_search_data: [], sportType: "ALL", eventName: "", marketType: "", marketName: "", mkts_name: [], evts_name: [], from: weekDate, to: curDate, bets_data: [], last_id: "", first_id: "", action: "", page_no: 1, count_records: 0, records_display: 25 })
   }

   async onEventList() {
      this.setState({ eventLoader: true, evts_name: [], eventName: "", mkts_name: [], marketName: "", marketType: "" },
         () => {
            currentBetsService.getEventListByEventTypeName(this.state.sportType).then((res) => {
               if (res.isSuccess) {
                  this.setState({ evts_name: res.items, eventLoader: false });
               }
               else {
                  // this.props.notify("No Events Found!", "error")
                  this.setState({ evts_name: [], eventLoader: false });
               }
            })
         })
   }

   async onMarketList() {
      this.setState({ marketLoader: true, mkts_name: [], marketName: "" },
         () => {
            currentBetsService.getMarketListByEventName(this.state.eventName, this.state.marketType).then((res) => {
               if (res.isSuccess) {
                  this.setState({ mkts_name: res.items, marketLoader: false });
               }
               else {
                  // this.props.notify("No Markets Found!", "error")
                  this.setState({ mkts_name: [], marketLoader: false });
               }
            })
         })
   }

   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      if (name === "records_display") {
         this.setState({ [name]: value, last_id: "", action: "", first_id: "", page_no: 1 }, () => { this.submitForm() });
      }
      else if (name === "sportType" && value !== "ALL") {
         this.setState({ [name]: value }, () => {
            // if (value !== "LOTUS" && value !== "SUPERNOVA" && value !== "DRC" && value !== "EVOLUTION"  && value !== "DIGITAIN") {
            if ( !(this.state.casinoShowList.includes(value)) && value !== "DIGITAIN") {
               this.onEventList()
            } else {
               this.setState({ evts_name: [], eventName: "", mkts_name: [], marketName: "", marketType: "" })
            }
         })
      }
      else if (name === "sportType") {
         this.setState({ [name]: value }, () => {
            this.onEventList()
         })
      }
      else if (name === "marketType" && value !== "" && !!this.state.eventName) {
         this.setState({ 
            [name]: value, 
            marketName: "" 
         },
            () => {
               this.onMarketList()
            }
         )
      }
      else if (name === "eventName" && this.state.marketType !== "" && !!value) {
         this.setState({ [name]: value },
            () => {
               this.onMarketList()
            }
         )
      }
      else {
         this.setState({ [name]: value })
      }
   }
   async onUserSearch(e, name, value) {
      if (value.length > 1) {
         this.setState({ [name]: value })
         let res = await userService.getUserSearch(this.state.accounts, value)
         let lst = []
         for (let x of res.usersList) {
            lst.push({ label: x, value: x, title: x, name: x })
         }
         lst.sort(function(a, b) {
             if(a.value.toLowerCase() < b.value.toLowerCase()) return -1;
             if(a.value.toLowerCase() > b.value.toLowerCase()) return 1;
             return 0;
         });
         this.setState({ usersList: lst })
      }
      else {
         this.setState({ [name]: value, usersList: [] })
      }
   }
   onSearch(e) {
      const value = e.target.value;
      let bets_lst = []
      if (this.state.bets_search_data) {
         bets_lst = _.filter(this.state.bets_search_data, function (obj) {
            return JSON.stringify(obj).toLowerCase().indexOf(value.toLowerCase()) !== -1;
         });
         this.setState({ bets_data: [] }, () => {
            this.setState({ bets_data: bets_lst })
         });
      }
   }
   onAction(e) {
      const name = e.target.name;
      const value = e.target.value;
      if (name === "page_no") {
         this.setState({ [name]: parseInt(value), last_id: "", action: "", first_id: "" }, () => { this.submitForm(); });
      }
      if (name === "last") {
         this.setState({ page_no: this.state.total_page, last_id: "", action: "", first_id: "" }, () => { this.submitForm(); });
      }
      else if (name === "prev" || name === "next" || name === "first") {
         this.setState({ action: name }, () => { this.submitForm(); });
      }
   }
   onDateTimeChange(name, e) {
      this.setState({ [name]: e._d })
   }
   onPagination() {
      let lst = []
      let total_page = this.state.total_page
      for (let x = 1; x <= total_page; x++) {
         if (this.state.page_no === x || Math.abs(x - this.state.page_no) <= 2 || (this.state.page_no < 3 && x < 6) || (total_page - this.state.page_no < 3 && total_page - x < 5)) {
            let htm = <button className={this.state.page_no === x ? "btn btn-blue active pagewidth" : "btn btn-blue pagewidth"} key={"unsettle_btn_" + x} name="page_no" value={x} onClick={(e) => { this.onAction(e) }}>{x} </button>
            lst.push(htm)
         }
      }
      return lst
   }

   getEventMarketDictionary(event_dict) {
      this.setState({ event_dictionary: event_dict })
   }

   render() {
      let page_no = parseInt(this.state.page_no)
      let count_records = parseInt(this.state.count_records)
      let records_display = parseInt(this.state.records_display)
      let current_record = 0
      let total_record = 0
      let start_record = 0
      if (count_records > (records_display * page_no)) {
         current_record = records_display * page_no
         total_record = count_records
         start_record = current_record - (records_display - 1)
      } else if (this.state.bets_data.length > 0) {
         current_record = count_records
         total_record = count_records
         start_record = ((page_no - 1) * records_display) + 1
      }
      return (
         <div className="bethubs">
            <Header history = {this.props.history} getEventMarketDictionary={(event_dict) => this.getEventMarketDictionary(event_dict)}/>
            <div className="wrapper">
               <div className="container-fluid container-padding-0">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="main-box">
                           <h5 className="text-blue">Current Bets</h5>
                           <div className="row mt-2">
                              <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
                                 <div className="form-group font-12">
                                    <Datetime
                                       value={this.state.from}
                                       onChange={(e) => this.onDateTimeChange("from", e)}
                                       id="from_datetime"
                                       dateFormat={"DD/MM/YYYY"}
                                       timeFormat={"HH:mm"}
                                    />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
                                 <div className="form-group font-12">
                                    <Datetime
                                       value={this.state.to}
                                       onChange={(e) => this.onDateTimeChange("to", e)}
                                       id="to_datetime"
                                       dateFormat={"DD/MM/YYYY"}
                                       timeFormat={"HH:mm"}
                                    />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    {/* <label className="mb-0 pb-1 mt-1">Select Sport</label> */}
                                    <select title="Sport" className="form-control" name="sportType" value={this.state.sportType} onChange={(e) => { this.onChange(e) }}>
                                       <option value="ALL">Select Sport</option>
                                       <option value="Cricket">Cricket</option>
                                       <option value="Football">Soccer</option>
                                       <option value="Tennis">Tennis</option>
                                       <option value="Kabaddi">Kabaddi</option>
                                       <option value="Election">Election</option>
                                       <option value="HorseRacing">Horse Racing</option>
                                       <option value="GreyhoundRacing">Greyhound Racing</option>
                                       <option value="Binary">Binary</option>
                                       <option value="DIGITAIN">SportBook</option>
                                       {casinoList.map((itm, i) => {
                                          return( itm.show &&
                                             <option value={itm.provider}>{itm.displayName}</option>
                                          );
                                       })}
                                       {/* <option value="LOTUS">Indian Poker</option>
                                       {/* <option value="SUPERNOVA">Indian Poker2</option> *}
                                       <option value="DRC">Casino</option>
                                       <option value="EVOLUTION">Evolution</option> */}
                                       {/* {this.state.operators_list.length > 0 ? this.state.operators_list.map((operator, i) => <option key={i} value={operator}>{operator}</option>) : ""} */}
                                    </select>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    {/* <label className="mb-0 pb-1 mt-1">Select Event</label> */}
                                    <div className="input-group">
                                       <select title="Event" className="form-control" name="eventName" value={this.state.eventName} onChange={(e) => { this.onChange(e) }} disabled={(!(this.state.casinoShowList.includes(this.state.sportType)) && this.state.sportType !== "DIGITAIN") ? false : true}>
                                          <option value="">Select Event</option>
                                          {this.state.evts_name.length > 0 ? this.state.evts_name.map((evt, i) => { return (<option key={evt.eventId + "_" + i} value={evt.eventId}>{evt.eventName}{this.state.sportType !== "Binary" && ` - ${new Date(evt.openDate).toLocaleDateString("hi-IN")}`}</option>) }) : ""}
                                       </select>
                                       {this.state.eventLoader &&
                                          <span className="input-group-addon">
                                             <i className="fa fa-refresh fa-spin"></i>
                                          </span>
                                       }
                                    </div>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    {/* <label className="mb-0 pb-1 mt-1">Select Market Type</label> */}
                                    <select title="Market Type" className="form-control" name="marketType" value={this.state.marketType} onChange={(e) => { this.onChange(e) }} disabled={(!(this.state.casinoShowList.includes(this.state.sportType)) && this.state.sportType !== "DIGITAIN") ? false : true}>
                                       <option value="">Select Market Type</option>
                                       {(this.state.sportType === "Cricket" || this.state.sportType === "Football" || this.state.sportType === "Tennis") && <option value="ODDS">Odds</option>}
                                       {(this.state.sportType === "Cricket" || this.state.sportType === "Football" || this.state.sportType === "Tennis" || this.state.sportType === "Election" || this.state.sportType === "Kabaddi") && <option value="BOOKMAKER">Bookmaker</option>}
                                       {(this.state.sportType === "Cricket" || this.state.sportType === "Election" || this.state.sportType === "Kabaddi") && <option value="LINE">Fancy</option>}
                                       {/* {(this.state.sportType === "Cricket" || this.state.sportType === "Football" || this.state.sportType === "Tennis") && <option value="MINI_BOOKMAKER">Mini Bookmaker</option>} */}
                                       {/* {this.state.sportType === "Football" && <option value="OVER_UNDER_05">Over/Under 0.5 Goals</option>}
                                       {this.state.sportType === "Football" && <option value="OVER_UNDER_25">Over/Under 2.5 Goals</option>}
                                       {this.state.sportType === "Football" && <option value="OVER_UNDER_15">Over/Under 1.5 Goals</option>}
                                       {this.state.sportType === "Football" && <option value="OVER_UNDER_35">Over/Under 3.5 Goals</option>}
                                       {(this.state.sportType === "HorseRacing" || this.state.sportType === "GreyhoundRacing" )&& <option value="WIN">Win</option>}
                                       {this.state.sportType === "Binary" && <option value="DAILY">Daily</option>}
                                       {this.state.sportType === "Binary" && <option value="1_HOUR">1 Hour</option>}
                                       {this.state.sportType === "Binary" && <option value="2_HOUR">2 Hour</option>} */}
                                       {/* {this.state.operators_list.length > 0 ? this.state.operators_list.map((operator, i) => <option key={i} value={operator}>{operator}</option>) : ""} */}
                                    </select>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    {/* <label className="mb-0 pb-1 mt-1">Select Market</label> */}
                                    <div className="input-group">
                                       <select title="Market" className="form-control" name="marketName" value={this.state.marketName} onChange={(e) => { this.onChange(e) }} disabled={(this.state.marketType !== "" && !!this.state.eventName && this.state.sportType !== "LOTUS" && this.state.sportType !== "SUPERNOVA" && this.state.sportType !== "DRC"  && this.state.sportType !== "EVOLUTION"  && this.state.sportType !== "DIGITAIN") ? false : true}>
                                          <option value="">Select Market</option>
                                          {this.state.mkts_name.length > 0 ? this.state.mkts_name.map((mkt, i) => <option key={mkt.marketId + "_" + i} value={mkt.marketId}>{mkt.marketName}</option>) : ""}
                                       </select>
                                       {this.state.marketLoader &&
                                          <span className="input-group-addon">
                                             <i className="fa fa-refresh fa-spin"></i>
                                          </span>
                                       }
                                    </div>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
                                 <div className="form-group font-12 autocomplete-wrapper">
                                    <Autocomplete
                                       value={this.state.user_id}
                                       items={this.state.usersList}
                                       getItemValue={item => item.title}
                                       renderItem={(item, isHighlighted) =>
                                          <div className={`item ${isHighlighted ? 'selected-item' : ''}`}>
                                             {item.title}
                                          </div>
                                       }
                                       inputProps={{ placeholder: 'Search by client' }}
                                       name="user_id"
                                       onChange={(event, user_id) => this.onUserSearch(event, "user_id", user_id)}
                                       onSelect={user_id => this.setState({ user_id })}
                                    />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
                                 <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                    <button className="btn btn-blue" disabled={!!this.state.from && !!this.state.to ? false : true} onClick={(e) => this.onSubmit(e)}>Go</button>
                                    <button className="btn btn-blue ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                 </div>
                              </div>
                           </div>
                           {!this.state.showData && !!this.state.loader ? <div className="ml-2 mt-2">Loading......</div> : null}
                           {!!this.state.showData && <div>
                              <div className="row text-center mt-2">
                                 <div className="col-6 col-sm-6 col-md-6 col-lg-6 mt-1">
                                    <div className="d-flex float-left">
                                       <div className="form-group mb-0 d-inline">
                                          <input className="form-control" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" />
                                       </div>
                                       <CSVLink
                                          data={this.state.csv_json}
                                          filename={"Current-Bets.csv"}
                                          asyncOnClick={true}
                                          className="d-none"
                                          ref={this.csvLink}>
                                       </CSVLink>
                                       <button className="btn btn-sm csv-icon d-inline p-0" title="Export Data" onClick={(e) => this.onDownload(e)} disabled={this.state.bets_data.length > 0 ? false : true}><img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon.svg`}></img></button>
                                       <div style={{ display: "none" }}>
                                          <div id="printJS-div">
                                             <table id="exportall" className="table font-12 table-bordered table-sm" style={{ border: "1px solid #000", color: "#212529", fontSize: '12px' }} >
                                                <thead >
                                                   <tr>
                                                      <th className="text-left pthead rw-80">Date &amp; Time</th>
                                                      <th className="text-left pthead">User</th>
                                                      <th className="text-left pthead">Competition</th>
                                                      <th className="text-left pthead">Event</th>
                                                      <th className="text-left pthead">Market</th>
                                                      <th className="text-left pthead">Runner</th>
                                                      <th className="text-left pthead rw-40">Side</th>
                                                      <th className="text-right pthead rw-40">Line</th>
                                                      <th className="text-right pthead rw-45">Rate</th>
                                                      <th className="text-right pthead rw-80">Amount</th>
                                                      <th className="text-right pthead rw-80" title="Potential Profit">PP</th>
                                                      <th className="text-right pthead rw-80" title="Potential Loss">PL</th>
                                                      <th className="text-left pthead rw-80">Client IP</th>
                                                   </tr>
                                                </thead>
                                                <tbody>
                                                   {this.state.pdf_json.length > 0 ? this.state.pdf_json.map((order, i) => {
                                                      let st = (order.createdAt).split(" ")
                                                      let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                                      let dt = new Date(dtstr).toLocaleString("hi-IN")
                                                      let price = order.price
                                                      if(price.toString().indexOf('.') > -1){
                                                         price = price.toFixed(2);
                                                      }
                                                      let competitionName = order.competitionName ? (order.eventTypeId === '300' ? dateUtil.getBinaryCompetitionDisplayName(order.competitionName) : order.competitionName) : "-"
                                                   if(order.eventTypeId === '300'){
                                                            order.marketTime =  dateUtil.getBinaryMarketDisplayName(order.marketName)
                                                        }
                                                      return (
                                                         <tr key={i} bgcolor={order.side === 0 ? "#72BBEF" : order.side === 1 ? "#FAA9BA" : "#FFFFFF"}>
                                                            <td className="text-left" title={!!dt ? dt : "-"}>{!!dt ? dt : "-"}</td>
                                                            <td className="text-left">{order.username ? order.username : "-"}</td>
                                                            <td className="text-left">{competitionName}</td>
                                                            <td className="text-left">{!!order.eventName ? order.eventName : "-"}</td>
                                                            <td className="text-left">{order.eventTypeId === '300' && !!order.marketTime && order.marketTime.length > 0 ? 
                                                            <>
                                                            {order.marketTime[0] }
                                                            <span className=''> [<b>{(order.marketTime.length > 0 ? order.marketTime[1] : "")}</b>]</span>
                                                            </>
                                                            
                                                            : !!order.marketName ? order.marketName : "-"}</td>
                                                            <td className="text-left">{!!order.runnerName ? order.runnerName : "-"}</td>
                                                            <td className="text-left">{order.side === 0 ? "Back" : order.side === 1 ? "Lay" : order.side === -1 ? "Unknown" : "-"}</td>
                                                            <td className="text-right fbold">{order.marketBettingType === "LINE" && !!order.runnerId ? order.runnerId : "-"}</td>
                                                            <td className="text-right fbold">{!!price ? price : "0.00"} </td>
                                                            <td className="text-right fbold">{!!order.amount ? <Currency key={"unsettlepd_amt_" + 1} className="fbold" amount={order.amount} showColor={false} /> : "-"}</td>
                                                            {order.eventTypeId !== "99" ?
                                                               <td className="text-right fbold">{!!order.potentialProfit ? <Currency key={"unsettlepd_pp_" + 1} className="fbold text-green" amount={order.potentialProfit} showColor={false} /> : "-"}</td>
                                                               : <td className="text-right">-</td>
                                                            }
                                                            {order.eventTypeId !== "99" ?
                                                               <td className="text-right fbold">{!!order.potentialLoss ? <Currency key={"unsettlepd_pl_" + 1} className="fbold text-red" amount={order.potentialLoss} showColor={false} /> : "-"}</td>
                                                               : <td className="text-right">-</td>
                                                            }
                                                            <td className="text-left">{!!order.clientIp ? order.clientIp : "-"}</td>
                                                         </tr>
                                                      );
                                                   }) : <tr>
                                                      <td colSpan={25} align="center" bgcolor="#FFFFFF">
                                                         No Data Found.
                                                         </td>
                                                   </tr>}
                                                </tbody>
                                             </table>
                                          </div>
                                       </div>
                                       <button className="btn btn-sm pdf-icon d-inline p-0" title="Export Data" onClick={(e) => this.onPDFDownload(e)} disabled={this.state.bets_data.length > 0 ? false : true}>
                                          <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon.svg`}></img>
                                       </button>
                                       {/* <button className="btn btn-sm d-inline csv-icon-all p-0 mx-2" title="Export All Data" onClick={(e) => this.onDownload(e)} disabled={this.state.bets_data.length > 0 ? false : true}>
                                          <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon-all.svg`}></img>
                                          </button>
                                        <button className="btn btn-sm pdf-icon-all d-inline p-0" title="Export All Data" onClick={(e) => this.onPDFDownload(e)} disabled={this.state.bets_data.length > 0 ? false : true}>
                                           <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon-all.svg`}></img>
                                       </button> */}
                                    </div>
                                 </div>
                                 <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                                    <span className="d-inline search-report"> &nbsp; entries </span>
                                    <div className="form-group font-12 float-right mb-0">
                                       <select onChange={(e) => { this.onChange(e) }} className="form-control" name="records_display" value={this.state.records_display}>
                                          <option value="25">25</option>
                                          <option value="50">50</option>
                                          <option value="100">100</option>
                                       </select>
                                    </div>
                                    <span className="d-inline search-report mr-2">Show</span>
                                 </div>
                              </div>
                              <div className="row">
                                 <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <div className="table-responsive">
                                       <table id="example" className="table font-12 table-bordered table-sm addpadding mt-2 whitespace">
                                          <thead>
                                             <tr>
                                                <th className="pthead">Date &amp; Time</th>
                                                <th className="pthead">User</th>
                                                <th className="pthead">Competition</th>
                                                <th className="pthead">Event</th>
                                                <th className="pthead">Market</th>
                                                <th className="pthead rw-120">Runner</th>
                                                <th className="pthead rw-40">Side</th>
                                                <th className="text-right pthead rw-40">Line</th>
                                                <th className="text-right pthead rw-45">Rate</th>
                                                <th className="text-right pthead rw-80">Amount</th>
                                                <th className="text-right pthead rw-80" title="Potential Profit">PP</th>
                                                <th className="text-right pthead rw-80" title="Potential Loss">PL</th>
                                                <th className="pthead rw-80">Client IP</th>
                                             </tr>
                                          </thead>
                                          <tbody>
                                             {!!this.state.loader ?
                                                <tr>
                                                   <td colSpan={15} align="center">
                                                      Loading......
                                                    </td>
                                                </tr> :
                                                this.state.bets_data.length > 0 ? this.state.bets_data.map((order, i) => {
                                                   let st = (order.createdAt).split(" ")
                                                   let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                                   let dt = new Date(dtstr).toLocaleString("hi-IN")
                                                   let price = order.price
                                                   if(price.toString().indexOf('.') > -1){
                                                      price = price.toFixed(2);
                                                   }
                                                   let competitionName = order.competitionName ? (order.eventTypeId === '300' ? dateUtil.getBinaryCompetitionDisplayName(order.competitionName) : order.competitionName) : "-"
                                                   if(order.eventTypeId === '300'){
                                                      order.marketTime =  dateUtil.getBinaryMarketDisplayName(order.marketName)
                                                   }
                                                   const eventDetail = this.state.event_dictionary[order.eventId]
                                                   const eventdate = !!eventDetail && !!eventDetail.openDate ? moment(eventDetail.openDate).format('DD MMM YY') : '';
                                                   return (
                                                      <tr key={i} bgcolor={order.side === 0 ? "#72BBEF" : order.side === 1 ? "#FAA9BA" : ""}>
                                                         <td title={!!dt ? dt : "-"}>{!!dt ? dt : "-"}</td>
                                                         <td>{order.username ? order.username : "-"}</td>
                                                         <td className="dtwidth" title={competitionName} >{competitionName}</td>
                                                         <td title={!!order.eventName ? order.eventName : "-"}>{!!order.eventName ? order.eventName : "-"} {eventdate !== '' ? ` - ${eventdate}` : ''}</td>
                                                         <td className="" title={!!order.marketName ? order.marketName : "-"}>{order.eventTypeId === '300' && !!order.marketTime && order.marketTime.length > 0 ? 
                                                            <>
                                                            {order.marketTime[0] }
                                                            <span className=''> [<b>{(order.marketTime.length > 0 ? order.marketTime[1] : "")}</b>]</span>
                                                            </>
                                                            
                                                            : !!order.marketName ? order.marketName : "-"}</td>
                                                         <td className="idwidthrunner">{!!order.runnerName ? order.runnerName : "-"}</td>
                                                         <td>{order.side === 0 ? "Back" : order.side === 1 ? "Lay" : order.side === -1 ? "Unknown" : "-"}</td>
                                                         <td className="text-right fbold">{order.marketBettingType === "LINE" && !!order.runnerId ? order.runnerId : "-"}</td>
                                                         <td className="text-right fbold">{!!price ? price : "0.00"} </td>
                                                         <td className="text-right fbold">{!!order.amount ? <Currency key={"unsettle_amt_" + 1} className="fbold" amount={order.amount} showColor={false} /> : "-"}</td>
                                                         {order.eventTypeId !== "99" ?
                                                            <td className="text-right fbold">{!!order.potentialProfit ? <Currency key={"unsettle_pp_" + 1} className="fbold text-green" amount={order.potentialProfit} showColor={false} /> : "-"}</td>
                                                            : <td className="text-right">-</td>
                                                         }
                                                         {order.eventTypeId !== "99" ?
                                                            <td className="text-right fbold">{!!order.potentialLoss ? <Currency key={"unsettle_pl_" + 1} className="fbold text-red" amount={order.potentialLoss} showColor={false} /> : "-"}</td>
                                                            : <td className="text-right">-</td>
                                                         }
                                                         <td>{!!order.clientIp ? order.clientIp : "-"}</td>
                                                      </tr>
                                                   );
                                                }) : <tr>
                                                   <td colSpan={25} align="center">
                                                      No Data Found.
                                       </td>
                                                </tr>}
                                          </tbody>
                                       </table>
                                    </div>
                                    <div className="row">
                                       <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {start_record} - {current_record} of {total_record} entries</span></div>
                                       <div className="col-12 col-sm-12 col-md-6">
                                          <div className="btn-group float-right" role="group" aria-label="Basic example" id="pagination-btn">
                                             <button type="button" className="btn btn-blue" id="PrevPage" name="first" onClick={(e) => this.onAction(e)} disabled={this.state.first_id === "" && this.state.page_no === 1 ? true : false}>First</button>
                                             <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.first_id === "" && this.state.page_no === 1 ? true : false}>Prev</button>
                                             {this.onPagination()}
                                             <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.last_id === "" && this.state.page_no === this.state.total_page ? true : false}>Next</button>
                                             <button type="button" className="btn btn-blue" id="NextPage" name="last" onClick={(e) => this.onAction(e)} disabled={this.state.last_id === "" && this.state.page_no === this.state.total_page ? true : false}>Last</button>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                              </div>
                           </div>}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <Footer />
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(CurrentBets);